import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ConfigurationService as CheckoutConfigurationService, CheckoutModule } from '@bytel/checkout';

import { BtlTranslateServices } from '@base/services/btl-translate.services';

import { ProductsService } from '@catalog/products.service';

import { BasicObject } from '@app/common/models/services.interface';
import { FooterComponent } from '@app/components/footer/footer.component';
import { HeaderComponent } from '@app/components/header/header.component';
import { IGlobal, OptionGraphQL, OptionPicasso, Options } from '@app/interfaces/config.interface';
import { initializeProvider } from '@app/services/initialize.provider';

import { ConfigurationService } from '@common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ModalService } from '@trilogy';
import { CookieModule } from 'ngx-cookie';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UniversalStorageService } from './base/services/universal-storage.service';
import { SharedForAllModule } from './base/shared-for-all.module';
import { OPTIONS_CONFIG } from './common/app.config';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
// export function setupTranslateFactory(service: TranslateService): () => void {
//     return () => {
//         service.use('fr');
//     };
// }

export interface IInitialConfig {
    oauth: {
        resourceUrl: string;
        baseUrl: string;
        logoutUrl: string;
        local: string;
        failureUrl: string;
        xSource: string;
        xBanc?: string;
        mon_compte_url?: string;
        salesApiVersion?: string;
    };
    widgets: {
        faiRoc: string;
        faiElig: string;
    };
    picasso: OptionPicasso;
    graphQL: OptionGraphQL;
    corbisActive: boolean;
    eligPtoActive: boolean;
    environment: string;
    global: IGlobal;
    version: 'stable' | 'canary';
}

declare global {
    interface Window {
        ConfigInitial: IInitialConfig;
        tc_vars: BasicObject;
    }
}

export const getCommonInitialConfig = (): Options => ({
    environment: window.ConfigInitial.environment,
    global: window.ConfigInitial.global,
    picasso: {
        emptycallBackUrl: null,
        loginUrl: null,
    },
    oauth: {
        baseUrl: window.ConfigInitial.oauth.baseUrl,
        failureUrl: window.ConfigInitial.oauth.failureUrl,
        logoutUrl: window.ConfigInitial.oauth.logoutUrl,
        resourceUrl: window.ConfigInitial.oauth.resourceUrl,
        xBanc: window.ConfigInitial.oauth.xBanc,
        xSource: window.ConfigInitial.oauth.xSource,
    },
    widgets: {
        faiElig: window.ConfigInitial.widgets.faiElig,
        faiRoc: window.ConfigInitial.widgets.faiRoc,
    },
});

// map config web to config for common
const CONFIG: () => Options = () => getCommonInitialConfig();

registerLocaleData(localeFr);

@NgModule({
    declarations: [AppComponent, HeaderComponent, FooterComponent],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        CookieModule.forRoot(),
        SharedForAllModule.forRoot(),
        CheckoutModule.forRoot(CONFIG),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: BtlTranslateServices,
                deps: [HttpClient, UniversalStorageService, ConfigurationService],
            },

            isolate: true,
            useDefaultLang: true,
        }),
    ],
    providers: [
        {
            provide: APP_BASE_HREF,
            useValue: '/',
        },
        ProductsService,
        ModalService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeProvider,
            deps: [ConfigurationService, CheckoutConfigurationService],
            multi: true,
        },
        {
            provide: OPTIONS_CONFIG,
            useValue: CONFIG,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
